export type KycStatus =
  | 'processing'
  | 'verified'
  | 'canceled'
  | 'expired'
  | 'requires_input';

export interface KycToastConfig {
  type: 'success' | 'error' | 'info';
  title: string;
  description: string;
}

export const KYC_STATUS_TOASTS: Record<KycStatus, KycToastConfig> = {
  verified: {
    type: 'success',
    title: 'Verification Successful!',
    description: 'Your identity has been verified successfully.',
  },
  canceled: {
    type: 'error',
    title: 'Verification Canceled',
    description:
      'Your verification was canceled. Please try again to complete the process.',
  },
  expired: {
    type: 'error',
    title: 'Verification Expired',
    description:
      'Your verification session has expired. Please start a new verification.',
  },
  requires_input: {
    type: 'error',
    title: 'Verification Incomplete',
    description:
      'Verification was not completed. Please try again and provide all required information.',
  },
  processing: {
    type: 'info',
    title: 'Verification in Progress',
    description:
      'Your verification is in progress. Please wait for it to complete.',
  },
} as const;

/** Short status messages for modal/polling UI (aligned with Stripe verification_session events) */
export const KYC_STATUS_MESSAGES: Record<KycStatus, string> = {
  processing: 'Processing your verification...',
  verified: 'Verification complete.',
  canceled: 'Verification was canceled.',
  expired: 'Verification session expired.',
  requires_input: 'Additional information required.',
} as const;
